export const text =
`
I did HCI research in grad school.
`
